import { getAuthToken, getRefreshToken } from './authStorage';
import { refreshAccessToken } from './api';

const KEEP_ALIVE_MS = 40 * 60 * 1000;

let timerId = null;

export function startSessionKeepAlive() {
  stopSessionKeepAlive();
  timerId = window.setInterval(() => {
    if (document.visibilityState !== 'visible') return;
    if (!getAuthToken() || !getRefreshToken()) return;
    refreshAccessToken().catch(() => {
      /* interceptor cuida do 401 se necessário */
    });
  }, KEEP_ALIVE_MS);
}

export function stopSessionKeepAlive() {
  if (timerId != null) {
    clearInterval(timerId);
    timerId = null;
  }
}
